module.exports = __webpack_public_path__ + "img/reset.db8e5769.png";